import api from "@/api/v1-jwt/config/api";
import { useQuery } from "@tanstack/react-query";
import customerPaymentsQueryKeys from "./query-keys";
import { CustomerPayment } from "./types";

const getCustomerPayments = async (userId: string): Promise<CustomerPayment[]> => {
  const { data } = await api.get(`/platform/payments/${userId}`);
  return data?.data ?? [];
};

export const useCustomerPayments = (
  userId: string,
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: customerPaymentsQueryKeys.list(userId),
    queryFn: () => getCustomerPayments(userId),
    enabled: options?.enabled ?? !!userId,
  });
};
